// @flow
import * as React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import './styles.scss'

function ArticleLink({
  publisherDomain,
  articleId,
  title,
  lead
}: {
  publisherDomain: string,
  articleId: string,
  title: string,
  lead: string
}) {
  return (
    <a
      href={`https://www.${publisherDomain}/${articleId}`}
      target='_parent'
      className='item'
    >
      <i className='external icon top aligned' />
      <div className='content'>
        <div className='header'>{title}</div>
        {lead}
      </div>
    </a>
  )
}

export function ArticleList() {
  const publisherDomain = parseHostname().publicationDomain

  return (
    <aside
      className='ui segment article-list'
      style={{ backgroundColor: '#fff' }}
    >
      <h4 className='ui infographic tiny header'>
        Articles en lien avec «Game of Thrones»:
      </h4>
      <div className='ui icon very infographic list'>
        <ArticleLink
          publisherDomain={publisherDomain}
          articleId={'30567769'}
          lead={'«J’ai dit adieu à Jon Snow» - Le Matin Dimanche (ABO+)'}
        />
        <ArticleLink
          publisherDomain={publisherDomain}
          articleId={'24535324'}
          lead={'Indétrônable «Game of Thrones» - Le Matin Dimanche (ABO+)'}
        />
        <ArticleLink
          publisherDomain={publisherDomain}
          articleId={'17790884'}
          lead={'Game of thrones pour les nuls'}
        />
      </div>
    </aside>
  )
}
